// export const BASE_URL_DEV = "http://demo_shortcode_service.test/api";

export const BASE_URL_DEV = "https://demoshortcodeservice.v2nportal.com/api";
